import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@material-ui/core';
import React from 'react';
import useStyles from './styles';
import cx from 'classnames';
import { translate } from '../../../../../common/intl';
import useHover from '../../../../hooks/useHover';

interface Props {
  displayValue: string
  onEdit: () => void
  onReplace?: () => void
  onDelete?: () => void
}

const DisplayComponent: React.FC<Props> = ({
  displayValue,
  onEdit,
  onReplace,
  onDelete,
}) => {
  const classes = useStyles();
  const [editIconRef, isEditIconHovered] = useHover<HTMLSpanElement>();
  const [replaceIconRef, isReplaceIconHovered] = useHover<HTMLSpanElement>();
  const [deleteIconRef, isDeleteIconHovered] = useHover<HTMLSpanElement>();

  return (
    <div className={classes.boxContainer}>
      <span className={classes.span}>
        {displayValue}
      </span>
      <div className={classes.icons}>
        {onEdit && (
          <Tooltip title={translate('common.edit')}>
            <span ref={editIconRef}>
              <FontAwesomeIcon
                icon={isEditIconHovered ? solid('pen-to-square') : regular('pen-to-square')}
                className={cx(classes.editIcon, { [classes.editIconDisable]: !isEditIconHovered })}
                onClick={onEdit}
              />
            </span>
          </Tooltip>
        )}
        {onReplace && (
          <Tooltip title={translate('common.replace')}>
            <span ref={replaceIconRef}>
              <FontAwesomeIcon
                icon={isReplaceIconHovered ? solid('repeat') : regular('repeat')}
                className={cx(classes.editIcon, { [classes.editIconDisable]: !isReplaceIconHovered })}
                onClick={onReplace}
              />
            </span>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title={translate('common.retire')}>
            <span ref={deleteIconRef}>
              <FontAwesomeIcon
                icon={isDeleteIconHovered ? solid('square-minus') : regular('square-minus')}
                className={cx(classes.editIcon, classes.deleteIcon, { [classes.editIconDisable]: !isDeleteIconHovered })}
                onClick={onDelete}
              />
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default DisplayComponent;
